//@ts-ignore
import React from 'react';
import { GetServerSideProps } from 'next';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import PageNotFound from '@/pages/404';
import { useSDMCartContext, useSDMCustomerContext } from '@ldp/sdm-contexts';

import NonSduiComponent from '@/components/non-sdui/non-sdui.component';
import StoreLocator from '@/components/store-locator';

import { isPharmaprixBanner } from '@/utils';
import { HOST, PAGE_ID } from '@/data/constants';
import { useTrackPageView } from '@/hooks';
import { getServerSecret, initializeServerSecrets } from '@/utils/gsm/server-secrets';
import { GOOGLE_MAPS_STORE_DATA } from '@/api/store-locator';

export const getServerSideProps: GetServerSideProps = async () => {
  await initializeServerSecrets();
  const apiKey = await getServerSecret('GOOGLE_MAPS_API_KEY');
  const mapId = await getServerSecret('GOOGLE_MAPS_MAP_ID');
  const googleMapsStoreData: GOOGLE_MAPS_STORE_DATA = {
    googleMapsApiKey: apiKey || '',
    googleMapsMapId: mapId || ''
  }
  return { props: { layout: null, googleMapsStoreData } };
};

const StoreLocatorPage = ({
  layout,
  error,
  googleMapsStoreData,
}: {
  layout: null;
  error?: boolean;
  googleMapsStoreData?: GOOGLE_MAPS_STORE_DATA;
}) => {
  const { formatMessage } = useIntl();
  const router = useRouter();
  const { cartCount, isInitialCartCountUpdated, setPageId } = useSDMCartContext();
  const { pcOptimumAccount } = useSDMCustomerContext();

  setPageId(PAGE_ID.STORE_LOCATOR);
  useTrackPageView(cartCount, PAGE_ID.STORE_LOCATOR, pcOptimumAccount, isInitialCartCountUpdated);

  if (error) {
    return <PageNotFound />;
  }

  const isPharmaprix = isPharmaprixBanner();
  const currentUrlBase = isPharmaprix ? HOST.PHX_HOME : HOST.SDM_HOME;
  const hasPharmacyFiltersSelected = !!router.query['pharmacy-services'] && isPharmaprixBanner();
  const STORE_LOCATOR = 'store-locator';

  const constructStoreLocatorMetaData = () => {
    const seoTitle = isPharmaprix ? 'storeLocatorPhxTitle' : 'storeLocatorSdmTitle';
    const seoDescription = isPharmaprix ? 'storeLocatorPhxDescription' : 'storeLocatorSdmDescription';
    return {
      title: formatMessage({ id: seoTitle }),
      description: formatMessage({ id: seoDescription }),
      addMetaNoRobots: false,
      canonicalUrlSlug: STORE_LOCATOR,
      jsonLd: null,
    };
  };
  const seoMetaData = constructStoreLocatorMetaData();
  const seoWrapperData = {
    seoMetaData,
    currentUrlBase,
    jsonLdScript: '',
  };

  return (
    <NonSduiComponent {...seoWrapperData} isPhxPharmacyTab={hasPharmacyFiltersSelected}>
      <StoreLocator
        layout={layout}
        googleMapsStoreData={googleMapsStoreData}
      />
    </NonSduiComponent>
  );
};

export default StoreLocatorPage;
